import { render, staticRenderFns } from "./ScreenshotPopup.vue?vue&type=template&id=1c7be554&scoped=true"
import script from "./ScreenshotPopup.vue?vue&type=script&lang=js"
export * from "./ScreenshotPopup.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotPopup.vue?vue&type=style&index=0&id=1c7be554&prod&lang=scss"
import style1 from "./ScreenshotPopup.vue?vue&type=style&index=1&id=1c7be554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7be554",
  null
  
)

export default component.exports